import { render, staticRenderFns } from "./AxProjectStateEmpty.vue?vue&type=template&id=34c6ef28&functional=true&"
import script from "./AxProjectStateEmpty.vue?vue&type=script&lang=ts&"
export * from "./AxProjectStateEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports